import { FETCH_PAYMENT_DETAILS } from '../actions/types';

export default function paymentReducer(state = [], action) {
	switch (action.type) {
		case FETCH_PAYMENT_DETAILS:
			return action.payload;
		default:
			return state;
	}
}
